<template>
  <v-card class="mb-2 grey lighten-4">
    <v-card-title>
      <span class="subtitle-1 font-weight-light">{{ project.projectID }}</span>
      <span class="subtitle-1 font-weight-bold ml-3 indigo--text darken-4">{{ project.status }}</span>
      <v-spacer></v-spacer>
      <v-list-item-title class="indigo--text text--darken-2">{{ addressLine }}</v-list-item-title>
      <!-- <span class="ml-1 mt-n3" v-for="(type, index) in project.types" :key="index">
        <span class="chip-type" @click="showingAllTypes = true">{{ type }}</span>
      </span>-->
    </v-card-title>

    <v-row dense class="pt-0 ma-2 mt-n3 mb-3">
      <v-col cols="12">
        <v-sheet color="rgba(0, 0, 0, .05)" class="overflow-y-auto pl-1 pt-1" height="52">
          <ul v-for="type in project.types" :key="type" style="color: #5d5f90d6  !important">
            <span class="ml-n5 project-type"></span>
            <span class="ml-2 body-2">{{ type }}</span>
          </ul>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row dense class="pt-0 ma-2 mt-n3 mb-3">
      <v-col cols="7">
        <span v-if="project.cid">
          <div class="mt-1 body-2" v-text="clientName"></div>
          <!-- <div class="mt-1 body-2 font-weight-medium" v-text="addressLine"></div> -->
          <v-list-item-subtitle>{{ addressLine }}</v-list-item-subtitle>
        </span>
        <span v-else>
          <div class="mt-1 body-2">-- no client selected --</div>
        </span>
      </v-col>
      <v-col cols="5">
        <div class="font-italic caption font-weight-light mt-1">
          <div class>
            <span class="abb7">enquiry:</span>
            {{ formatDate(project.dateEnquiry) }}
          </div>
          <div class>
            <span class="abb7">start:</span>
            {{ formatDate(project.dateStarted) }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row dense class="pt-0 ma-2 mt-n2 mb-3">
      <v-col cols="5" class="caption">
        <div class="d-flex flex-row">
          <span class="font-italic">invoiced:</span>
          <v-spacer></v-spacer>
          <span class="mr-0 text-right">{{ formatNumber(project.invoiced) }}</span>
        </div>
        <div class="d-flex flex-row">
          <span class="font-italic">received:</span>
          <v-spacer></v-spacer>
          <span class="mr-0 text-right">{{ formatNumber(project.received) }}</span>
        </div>
        <div class="d-flex flex-row">
          <span class="font-italic">expenses:</span>
          <v-spacer></v-spacer>
          <span class="mr-0 text-right">{{ formatNumber(project.expense) }}</span>
        </div>
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="5" class="caption">
        <div class="d-flex flex-row">
          <span class="font-italic">profit (loss):</span>
          <v-spacer></v-spacer>
          <span class="mr-0 text-right">{{ formatNumber(project.profit) }}</span>
        </div>
        <div class="d-flex flex-row">
          <span class="font-italic">hrs. worked:</span>
          <v-spacer></v-spacer>
          <span class="mr-0 text-right">{{ project.hours }}</span>
        </div>
        <div class="d-flex flex-row">
          <span class="font-italic">fee/hour:</span>
          <v-spacer></v-spacer>
          <span class="mr-0 text-right">{{ formatNumber(project.hourlyfee) }}</span>
        </div>
      </v-col>
    </v-row>

    <!-- <div class="body-2 font-italic font-weight-light">
      <v-row dense class="mt-0">
        <v-col cols="6">
          <span class="body-2">enquiry: {{ formatDate(project.dateEnquiry) }}</span>
        </v-col>
        <v-col cols="6">
          <span class="body-2">proposal: {{ formatDate(project.dateProposal) }}</span>
        </v-col>
      </v-row>
      <v-row dense class="mt-n2">
        <v-col cols="6">
          <span class="body-2 text-left">accepted: {{ formatDate(project.dateAccepted) }}</span>
        </v-col>
        <v-col cols="6">
          <span class="body-2 text-left">start: {{ formatDate(project.dateStarted) }}</span>
        </v-col>
      </v-row>
    </div>-->
    <v-divider />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="showProjectDetails">View</v-btn>
    </v-card-actions>

    <!-- <template>
      <v-row justify="center">
        <v-dialog v-model="showingAllTypes" scrollable persistent max-width="290">
          <DialogTypesList :item="project" :close="closeDialog" />
        </v-dialog>
      </v-row>
    </template>-->
  </v-card>
</template>


<script>
//import DialogTypesList from "./DialogTypesList";
import { getFormattedDate, getFormattedValue } from "../../shared.js";

export default {
  name: "ProjectViewItem",
  //components: { DialogTypesList },
  props: {
    project: Object,
    //showProjectDetails: Function
  },
  data() {
    return {
      showingAllTypes: false,
    };
  },
  computed: {
    hasClient() {
      return this.project.client && this.project.client.lastName;
    },
    client() {
      if (this.project.client) return this.project.client;
      else return {};
    },
    addressLine() {
      if (!this.hasClient) return "-- no client --";
      return `${this.client.addressLine1}, ${this.client.city}`;
    },
    clientName() {
      if (!this.hasClient) return "-- no client --";
      return `${this.client.firstName}, ${this.client.lastName}`;
    },
    // dates() {
    //   return `enquired: ${getFormattedDate(
    //     this.project.enquiryDate
    //   )},  accepted: ${getFormattedDate(this.project.acceptedDate)}`;
    // }
  },
  methods: {
    showProjectDetails() {
      // make sure there is an array of workitems (in future don't allow new project without workitems)
      if (!this.project.hasOwnProperty("workItems"))
        this.project.workItems = [];

      // set this project to the the store selected project
      this.$store.dispatch("setSelectedProject", this.project);

      // raise the project-selected event
      this.$emit("project-selected");
    },
    formatDate(date) {
      if (date) return getFormattedDate(date);
      else return "n/a";
    },
    formatNumber(xx) {
      return getFormattedValue(xx);
    },
    closeDialog() {
      this.showingAllTypes = false;
    },
  },
};
</script>

<style scoped>
.card-listitem {
  background-color: #e4ecfb;
}

.abb7 {
  display: inline-block;
  width: 50px;
}

.project-type {
  width: 0;
  height: 0;
  display: inline-block;
  border-top: 4px solid transparent;
  border-left: 8px solid #7c7d82;
  border-bottom: 4px solid transparent;
}
</style>

<style>
.chip-type {
  display: inline-block;
  text-align: center;
  border: 1px solid gray;
  background-color: #546e7a;
  border-radius: 13px;
  width: 46px;
  padding: 3px;
  color: white;
  font-weight: 300 !important;
  font-size: 0.75rem !important;
  font-weight: 400;
  letter-spacing: 0.0333333333em !important;
  line-height: 1.25rem;
}
</style>

  